<template>
	<div class="container">
			<div class="row">
					<div class="col-12">
							<div class="titulo">
									<h3>Ranking de las 15 embarcaciones peruanas que más pescaron en reservas 2016-2024 (en toneladas)*</h3>
							</div>
					</div>
					<div class="col-12">
							<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
									<!--
								<ol class="carousel-indicators">
											<li v-for="(item, index) in data" :key="index" :data-target="carouselExampleIndicators" :data-slide-to="index" :class="{ active: index === 0 }"></li>
									</ol>
									-->
									<div class="carousel-inner">
											<div v-for="(item, index) in data" :key="index" :class="['carousel-item', { active: index === 0 }]">
													<div class="card mx-auto" style="max-width: 800px;">
															<img :src="item.photo" class="card-img-top" :alt="item.barco_name">
															<div class="card-body">
																	<h5 class="card-title">{{ item.barco_name }}</h5>
																	<p class="card-text">
																			<strong>Owner:</strong> {{ item.owner }}<br>
																			<strong>Badge:</strong> {{ item.badge }}<br>
																			<strong>Dorsal de Nasca:</strong> {{ item.dorsal_de_nasca }}<br>
																			<strong>Paracas:</strong> {{ item.paracas }}<br>
																			<strong>Mar de Grau:</strong> {{ item.mar_de_grau }}<br>
																			<strong>Total:</strong> {{ item.total }}
																	</p>
															</div>
													</div>
											</div>
									</div>
									<a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
											<span class="carousel-control-prev-icon" aria-hidden="true"></span>
											<span class="sr-only">Previous</span>
									</a>
									<a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
											<span class="carousel-control-next-icon" aria-hidden="true"></span>
											<span class="sr-only">Next</span>
									</a>
							</div>
					</div>
			</div>
	</div>
</template>

<script>
export default {
data() {
	return {
		data: [
			{"barco_name": "TASA 71", "owner": "TECNOLOGICA DE ALIMENTOS S.A", "badge": "CO-15233-PM", "photo": "./fotos/tasa71.jpg", "dorsal_de_nasca": "2 060", "paracas": "2 240", "mar_de_grau": 0, "total": "4 300"},
			{"barco_name": "DON OLE", "owner": "AUSTRAL GROUP", "badge": "CO-50608-PM", "photo": "./fotos/don_ole.png", "dorsal_de_nasca": "1 650", "paracas": "1 980", "mar_de_grau": 0, "total": "3 630"},
			{"barco_name": "CARMENCITA", "owner": "PESQUERA EXALMAR S.A.", "badge": "CO-15653-PM", "photo": "./fotos/carmencita.png", "dorsal_de_nasca": "1 410", "paracas": "2 030", "mar_de_grau": 0, "total": "3 440"},
			{"barco_name": "RODAS", "owner": "PESQUERA EXALMAR S.A.", "badge": "CO-15725-PM", "photo": "./fotos/rodas.png", "dorsal_de_nasca": "2 450", "paracas": 970, "mar_de_grau": 0, "total": "3 420"},
			{"barco_name": "TASA 59", "owner": "TECNOLOGICA DE ALIMENTOS S.A", "badge": "CO-17361-PM", "photo": "/fotos/tasa59.jpg", "dorsal_de_nasca": "1 370", "paracas": "1 830", "mar_de_grau": 0, "total": "3 200"},
			{"barco_name": "CRETA", "owner": "PESQUERA EXALMAR S.A.A.", "badge": "CO-18167-PM", "photo": "./fotos/creta.png", "dorsal_de_nasca": "2 070", "paracas": "1 070", "mar_de_grau": 0, "total": "3 140"}, 
			{"barco_name": "DON ALFREDO", "owner": "PESQUERA EXALMAR S.A.A.", "badge": "CO-29856-PM", "photo": "./fotos/don_alfredo.png", "dorsal_de_nasca": "2 210", "paracas": 920, "mar_de_grau": 0, "total": "3 130"},
			{"barco_name": "TASA 416", "owner": "TECNOLOGICA DE ALIMENTOS S.A", "badge": "HO-10722-PM", "photo": "./fotos/tasa416.jpg", "dorsal_de_nasca": 0, "paracas": "2 910", "mar_de_grau": 0, "total": "2 910"},
			{"barco_name": "TASA 418", "owner": "TECNOLOGICA DE ALIMENTOS S.A", "badge": "PT-10933-PM", "photo": "./fotos/tasa418.png", "dorsal_de_nasca": 0, "paracas": "2 910", "mar_de_grau": 0, "total": "2 910"}, 
			{"barco_name": "TASA 51", "owner": "TECNOLOGICA DE ALIMENTOS S.A", "badge": "CO-20761-PM", "photo": "./fotos/tasa51.jpg", "dorsal_de_nasca": "2 450", "paracas": 440, "mar_de_grau": 0, "total": "2 885"}
		]
	};
},
mounted() {
	this.fetchData();
},
methods: {
	fetchData() {
		fetch('/i18n/ranking.json')
			.then(response => response.json())
			.then(data => {
				this.data = data;
			})
			.catch(error => {
				console.error('Error fetching the JSON file:', error);
			});
	}
}
};
</script>

<style>

/* Carousel */
.carousel {
  margin-top: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

/* Carousel Indicators */
.carousel-indicators li {
  background-color: #007bff;
  border: 2px solid #fff;
  width: 10px;
  height: 10px;
}

.carousel-indicators .active {
  background-color: #fff;
  border-color: #007bff;
}

/* Carousel Controls */
.carousel-control-prev-icon,
.carousel-control-next-icon {
  filter: invert(100%);
}

/* Card */
.card {
  max-width: 800px;
  margin: 20px auto;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.card-img-top {
  width: 100%;
  height: 400px; /* Adjust this value to the desired height */
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.card-body {
  padding: 20px;
}

.card-title {
  font-size: 1.5rem;
  color: #007bff;
}

.card-text {
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
}

.card-text strong {
  color: #007bff;
}

/* Title */
.titulo h3 {
  font-size: 1.8rem;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

/* Add any additional styles you want */

</style>
